import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

export function HtmlLangSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.resolvedLanguage || i18n.language;
    document.documentElement.lang = lang;
  }, [i18n.resolvedLanguage, i18n.language]);

  return null;
}
